import styles from './Testimonials.module.css'
function Testimonials() {
    return (
        <div className={styles.banner} id='skils' >
            <div className={styles.slider} style={{ "--quantity": 7 }} >
                <div className={styles.item} style={{ "--position": 1 }}>
                    <img className={styles.img} src="/xp/HTML5_logo_and_wordmark.svg" alt="HTML" />
                </div>
                <div className={styles.item} style={{ "--position": 2 }}>
                    <img className={styles.img} src="/xp/CSS.3.svg" alt="HTML" />
                </div>
                <div className={styles.item} style={{ "--position": 3 }}>
                    <img className={styles.img} src="/xp/Unofficial_JavaScript_logo_2.svg" alt="HTML" />
                </div>
                <div className={styles.item} style={{ "--position": 4 }}>
                    <img className={styles.img} src="/xp/Tailwind_CSS_Logo.svg" alt="HTML" />
                </div>
                <div className={styles.item} style={{ "--position": 5 }}>
                    <img className={styles.img} src="/xp/React-icon.svg" alt="HTML" />
                </div>
                <div className={styles.item} style={{ "--position": 6 }}>
                    <img className={styles.img} src="/xp/firebase-svgrepo-com.svg" alt="HTML" />
                </div>
                <div className={styles.item} style={{ "--position": 7 }}>
                    <img className={styles.img} src="/xp/strapi-svgrepo-com.svg" alt="HTML" />
                </div>
            </div>
            <div className={styles.content}>
                <h1 data-content="HAIDAR">
                    HAIDAR
                </h1>
                <div className={styles.authar}>
                    <h2>FrontEnd</h2>
                    <p><b>web devoloper</b></p>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel laboriosam eos, debitis reprehenderit dolores quis vero temporibus voluptatem, earum eligendi quia labore assumenda blanditiis quo, modi ipsa cupiditate vitae officiis.</p>
                </div>
            </div>
            <div className={styles.model}>

            </div>
        </div>
    )
}

export default Testimonials
//  <img src="/xp/CSS.3.svg" alt="HTML" />
// <img src="/xp/Unofficial_JavaScript_logo_2.svg" alt="HTML" />
// <img src="/xp/Tailwind_CSS_Logo.svg" alt="HTML" />
// <img src="/xp/React-icon.svg" alt="HTML" />
// <img src="/xp/firebase-svgrepo-com.svg" alt="HTML" />
// <img src="/xp/strapi-svgrepo-com.svg" alt="HTML" />
// <img src="/xp/am.png" alt="" /> 